var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-spacing"},_vm._l((_vm.especes),function(e,i){return _c('espece',{key:i,attrs:{"espece":e}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }